export default "__VITE_ASSET__Dky_mQAd__"